import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import { formatWorkspaceEmailAliasAddress } from "@common/helpers/workspace-email-alias";
import { EmailAliasRow } from "./emailAliasesViewConfig";

interface DefaultEmailAliasEntity {
    id: number;
    slug: string | null;
}

interface BuildDefaultEmailAliasRowsParams {
    kind: Exclude<WorkspaceEmailAliasKind, "receipts">;
    search: string;
    workspaceId: string;
    entities: DefaultEmailAliasEntity[];
}

export function buildDefaultEmailAliasRows({
    kind,
    search,
    workspaceId,
    entities,
}: BuildDefaultEmailAliasRowsParams): EmailAliasRow[] {
    const normalizedSearch = search.trim().toLowerCase();

    return entities.flatMap((entity) => {
        if (!entity.slug) {
            return [];
        }

        const email = formatWorkspaceEmailAliasAddress({
            emailLocalPart: entity.slug,
            kind,
        });
        if (
            normalizedSearch.length > 0 &&
            !email.toLowerCase().includes(normalizedSearch)
        ) {
            return [];
        }

        return [
            {
                id: `default:${kind}:${entity.id}`,
                emailLocalPart: entity.slug,
                limit: null,
                workspaceId,
                kind,
                counterpartyId: null,
                counterpartyName: "Default",
                isDefault: true,
                createdAt: new Date(0),
                updatedAt: new Date(0),
            },
        ];
    });
}
